/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import { Container } from "reactstrap";

function TransparentFooter() {
  return (
    <footer className="footer">
      <Container>
        <nav>
          <ul>
            <li>
              <a href='/admin' >
                <i className="fas fa-user-lock"></i>&nbsp;Espace Sécurisé
              </a>
            </li>
          </ul>
        </nav>
        <div className="copyright" id="copyright">
          © {new Date().getFullYear()},
          Baptiste Desfontaines.<br />
          Édition Millenium.
        </div>
      </Container>
    </footer>
  );
}

export default TransparentFooter;
